<template>
  <div v-show="!hidden">
    <div
      class="my-4 derived-field-border"
    >
      <span class="font-weight-bold text-muted font-size-small my-2 d-flex">{{ label ? label: '' }}</span>
      <span class="derived-field-value">{{ config.value ? `${config.value}`: '—' }}</span>
    </div>
  </div>
</template>

<script>
import FormMixin from './FormMixin'
export default {
  name: 'FormHeading',
  mixins: [ FormMixin ],
}
</script>

<style scoped>
.derived-field-value{
  font-size: 1rem;
}
.derived-field-border {
  border-color: #D2D6DC !important
}
</style>
